import { setRoles } from "reduxStore/state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch all roles
export const fetchRoles = () => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/roles/roles`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to fetch roles");

    const roles = await response.json();
    dispatch(setRoles(roles));
    return roles;
  } catch (error) {
    console.error("Error while fetching roles:", error);
    return { error: error.message };
  }
};
